import { Injectable } from '@angular/core';
import { ContractProduct, ProductService } from '@cemex-core/cmx-api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import {
  AddedValueActionTypes,
  AddedValuesResetAction,
  LoadAddedValuesCompleteAction,
  LoadAddedValuesNotFormulatingAction,
} from '../actions/added-values.actions';
import { getProductsState } from '../selectors/products.selectors';

@Injectable()
export class AddedValuesNotFormulatingEffects {
  loadAddedValuesNotFormulating$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddedValueActionTypes.LOAD_ADDED_VALUES_NOT_FORMULATING),
      switchMap((action: LoadAddedValuesNotFormulatingAction) => {
        return this.store.select(getProductsState).pipe(
          take(1),
          filter(() => {
            if (!action.payload.addedValues) {
              // Enters here only when fetching first added values
              return true;
            } else {
              // If addedValues is defined, must contain trueable values
              // Can get undefined/null values when unselecting from combo box
              const valid = action.payload.addedValues.every((value) => !!value);
              if (!valid) {
                this.store.dispatch(
                  new LoadAddedValuesCompleteAction({
                    productCode: action.payload.productCode,
                    index: action.payload.index,
                    addedValues: null,
                    technicalProduct: null,
                  }),
                );
              }
              return valid;
            }
          }),
          switchMap((productState) => {
            const productSelected = productState.availableProducts.find(
              (product) => product.comm_product.comm_product.replace(/^0+/, '') === action.payload.productCode,
            );
            const contract = productSelected.comm_product.refDocuments.find(
              (item) => item.documentCode.replace(/^0+/, '') === action.payload.contractCode,
            );
            const contractSelected = {
              documentCode: contract.documentCode,
              refDocumentId: contract.refDocumentId,
            };
            const selectedContract = { selectedContract: contractSelected } as ContractProduct;

            return this.productService.requestAddedValues(
              productSelected,
              action.payload.addedValues,
              productState.valueAddedsNotCombinable,
              selectedContract,
            );
          }),
          map((response: any) => {
            return new LoadAddedValuesCompleteAction({
              productCode: action.payload.productCode,
              index: action.payload.index,
              addedValues: response.valueAdded,
              technicalProduct: response.technicalProduct as any,
            });
          }),
        );
      }),
      catchError((error) => {
        return of(new AddedValuesResetAction());
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<OrderBuilderState>,
    private productService: ProductService,
  ) {}
}
